import React from "react";
import { styled } from "styled-components";
import { ReactComponent as AwardIcon } from "./award.svg";
import { ReactComponent as VerifiedIconGrey } from "./blob-verified-grey.svg";
import { ReactComponent as VerifiedIcon } from "./blob-verified.svg";
import { ReactComponent as CheckGreenIcon } from "./check-green.svg";
import { ReactComponent as CheckDarkGreenIcon } from "./check-dark-green.svg";
import { ReactComponent as CheckIcon } from "./check.svg";
import { ReactComponent as CheckLightIcon } from "./check-light.svg";
import { ReactComponent as FlagIcon } from "./flag.svg";
import { ReactComponent as FontIcon } from "./font.svg";
import { ReactComponent as HouseIcon } from "./house.svg";
import { ReactComponent as ModelingIcon } from "./modeling.svg";
import { ReactComponent as ShieldIcon } from "./shield.svg";
import { ReactComponent as StrenghtIcon } from "./strenght.svg";
import { ReactComponent as TargetIcon } from "./target.svg";
import { ReactComponent as WebIcon } from "./web.svg";
import { ReactComponent as MailIcon } from "./mail.svg";
import { ReactComponent as MailIconLight } from "./mail-light.svg";
import { ReactComponent as MaxIcon } from "./max.svg";
import { ReactComponent as PhoneIcon } from "./phone.svg";
import { ReactComponent as InfoAccentIcon } from "./info-accent.svg";
import { ReactComponent as ShieldAccentIcon } from "./shield-accent.svg";
import { ReactComponent as BlockIcon } from "./block.svg";
import { ReactComponent as BrowserIcon } from "./browser.svg";
import { ReactComponent as CalculatorIcon } from "./calculator.svg";
import { ReactComponent as Dashboardicon } from "./dashboard.svg";
import { ReactComponent as DatabaseIcon } from "./database.svg";
import { ReactComponent as DocumentIcon } from "./document.svg";
import { ReactComponent as HeadphonesIcon } from "./headphones.svg";
import { ReactComponent as ImportIcon } from "./import.svg";
import { ReactComponent as InstallationIcon } from "./installation.svg";
import { ReactComponent as Measure } from "./measure.svg";
import { ReactComponent as NotificationIcon } from "./notification-ringing.svg";
import { ReactComponent as PassportIcon } from "./passport.svg";
import { ReactComponent as SettingsIcon } from "./settings.svg";
import { ReactComponent as TemperatureIcon } from "./temperature.svg";
import { ReactComponent as WarningIcon } from "./warning.svg";
import { ReactComponent as ChartIcon } from "./chart.svg";
import { ReactComponent as BoltIcon } from "./bolt.svg";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const Svg = styled.svg<IconProps>`
  width: ${({ size }) => size || 24}px;
  height: ${({ size }) => size || 24}px;
  color: ${({ color, theme }) => color || theme.colors.text};
  transition: color 0.2s;
`;

export const IconAward: React.FC<IconProps> = (props) => (
  <Svg as={AwardIcon} {...props} />
);

export const IconVerifiedGrey: React.FC<IconProps> = (props) => (
  <Svg as={VerifiedIconGrey} {...props} />
);

export const IconVerified: React.FC<IconProps> = (props) => (
  <Svg as={VerifiedIcon} {...props} />
);

export const IconCheckGreen: React.FC<IconProps> = (props) => (
  <Svg as={CheckGreenIcon} {...props} />
);

export const IconCheckDarkGreen: React.FC<IconProps> = (props) => (
  <Svg as={CheckDarkGreenIcon} {...props} />
);

export const IconCheckLight: React.FC<IconProps> = (props) => (
  <Svg as={CheckLightIcon} {...props} />
);

export const IconCheck: React.FC<IconProps> = (props) => (
  <Svg as={CheckIcon} {...props} />
);

export const IconFlag: React.FC<IconProps> = (props) => (
  <Svg as={FlagIcon} {...props} />
);

export const IconFont: React.FC<IconProps> = (props) => (
  <Svg as={FontIcon} {...props} />
);

export const IconHouse: React.FC<IconProps> = (props) => (
  <Svg as={HouseIcon} {...props} />
);

export const IconModeling: React.FC<IconProps> = (props) => (
  <Svg as={ModelingIcon} {...props} />
);

export const IconShield: React.FC<IconProps> = (props) => (
  <Svg as={ShieldIcon} {...props} />
);

export const IconStrenght: React.FC<IconProps> = (props) => (
  <Svg as={StrenghtIcon} {...props} />
);

export const IconTarget: React.FC<IconProps> = (props) => (
  <Svg as={TargetIcon} {...props} />
);

export const IconWeb: React.FC<IconProps> = (props) => (
  <Svg as={WebIcon} {...props} />
);

export const IconMail: React.FC<IconProps> = (props) => (
  <Svg as={MailIcon} {...props} />
);

export const IconMailLight: React.FC<IconProps> = (props) => (
  <Svg as={MailIconLight} {...props} />
);

export const IconMax: React.FC<IconProps> = (props) => (
  <Svg as={MaxIcon} {...props} />
);

export const IconPhone: React.FC<IconProps> = (props) => (
  <Svg as={PhoneIcon} {...props} />
);

export const IconInfoAccent: React.FC<IconProps> = (props) => (
  <Svg as={InfoAccentIcon} {...props} />
);

export const IconShieldAccent: React.FC<IconProps> = (props) => (
  <Svg as={ShieldAccentIcon} {...props} />
);

export const IconBlock: React.FC<IconProps> = (props) => (
  <Svg as={BlockIcon} {...props} />
);

export const IconBrowser: React.FC<IconProps> = (props) => (
  <Svg as={BrowserIcon} {...props} />
);

export const IconCalculator: React.FC<IconProps> = (props) => (
  <Svg as={CalculatorIcon} {...props} />
);

export const IconDashboard: React.FC<IconProps> = (props) => (
  <Svg as={Dashboardicon} {...props} />
);

export const IconDatabase: React.FC<IconProps> = (props) => (
  <Svg as={DatabaseIcon} {...props} />
);

export const IconDocument: React.FC<IconProps> = (props) => (
  <Svg as={DocumentIcon} {...props} />
);

export const IconHeadphones: React.FC<IconProps> = (props) => (
  <Svg as={HeadphonesIcon} {...props} />
);

export const IconImport: React.FC<IconProps> = (props) => (
  <Svg as={ImportIcon} {...props} />
);

export const IconInstallation: React.FC<IconProps> = (props) => (
  <Svg as={InstallationIcon} {...props} />
);

export const IconMeasure: React.FC<IconProps> = (props) => (
  <Svg as={Measure} {...props} />
);

export const IconNotification: React.FC<IconProps> = (props) => (
  <Svg as={NotificationIcon} {...props} />
);

export const IconPassport: React.FC<IconProps> = (props) => (
  <Svg as={PassportIcon} {...props} />
);

export const IconSettings: React.FC<IconProps> = (props) => (
  <Svg as={SettingsIcon} {...props} />
);

export const IconTemperature: React.FC<IconProps> = (props) => (
  <Svg as={TemperatureIcon} {...props} />
);

export const IconWarning: React.FC<IconProps> = (props) => (
  <Svg as={WarningIcon} {...props} />
);

export const IconChart: React.FC<IconProps> = (props) => (
  <Svg as={ChartIcon} {...props} />
);

export const IconBolt: React.FC<IconProps> = (props) => (
  <Svg as={BoltIcon} {...props} />
);
